import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { VersionBadge } from '../components/VersionBadge';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate('/', { replace: true });
    } catch (err: any) {
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 20 }}>
      <div className="card fade-in" style={{ width: 'min(400px, 100%)', padding: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 4 }}>
          <img src="/icons/DTB_2.png" alt="Dueña de tu Belleza" style={{ width: 'min(240px, 78%)', height: 'auto' }} />
          <div className="muted" style={{ fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', marginTop: 8 }}>
            HUB · Seguimiento y analítica
          </div>
        </div>

        <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12, marginTop: 18 }}>
          <label style={{ display: 'grid', gap: 6 }}>
            <span className="muted" style={{ fontSize: 13 }}>Correo</span>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@duenadetubelleza.com"
              required
            />
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span className="muted" style={{ fontSize: 13 }}>Contraseña</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          {error && (
            <div style={{ color: 'var(--warning)', background: 'var(--warning-bg)', padding: '10px 12px', borderRadius: 10, fontSize: 14 }}>
              {error}
            </div>
          )}

          <button type="submit" className="btn-primary" disabled={busy}>
            {busy ? 'Entrando…' : 'Iniciar sesión'}
          </button>
        </form>

        <div style={{ marginTop: 18, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span className="muted" style={{ fontSize: 12 }}>Login con Google — próximamente</span>
          <VersionBadge />
        </div>
      </div>
    </div>
  );
}
